import VueCookies from "vue-cookies";
export function deleteLogoutCookies() {
  VueCookies.remove("user-token");
  VueCookies.remove("user-type");
  VueCookies.remove("user-name");
  VueCookies.remove("user-role");
  VueCookies.remove("user-email");
}
export function debounce(fn, delay) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}
export function formatDate(date) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
}
